import { Loader as DSLoader } from '@mc/design-system'

export const Loader = () => (
  <div className='d-flex justify-content-center align-items-center'>
    <DSLoader width='60' color='#596170' />
  </div>
)
